export const WhiteListSearchKeys = {
    Tzid: "tzid"
};
